export class market_location{
  id:number;
  market_name:string;
  location_name:string;
  email_address:string;
  remedy_support_group:string;
  remedy_ticket_summary:string;

}
